import React from 'react';
import { useSelector } from 'react-redux';
import { USER_PREFERENCE_SETS } from 'common/utils/constants';
import { selectUserPreferences } from 'redux/selectors';
import { selectUserCategoryPreferences } from 'redux/UserPreferences';
import { PerfectScrollbar } from 'components/shared/ReactPerfectScrollbar';
import { fallbackByCategory } from '../../constants';
import ChartSetPreferenceListItem from './ChartSetPreferenceListItem';
import styles from './ChartSetPreferenceList.module.css';

const fallbackIds = fallbackByCategory[USER_PREFERENCE_SETS.CHART_SET];

function ChartSetPreferenceList({ defaultPreferenceId, onUpdateName, onToggleDefault, onDelete }) {
  const ids = useSelector(
    (state) => selectUserCategoryPreferences(selectUserPreferences(state), USER_PREFERENCE_SETS.CHART_SET).ids
  );

  const allIds = [...fallbackIds, ...ids];

  return (
    <PerfectScrollbar>
      {allIds.length > 0 ? (
        allIds.map((id) => (
          <ChartSetPreferenceListItem
            key={id}
            preferenceId={id}
            defaultPreferenceId={defaultPreferenceId}
            onUpdateName={onUpdateName}
            onToggleDefault={onToggleDefault}
            onDelete={onDelete}
          />
        ))
      ) : (
        <div className={styles.message}>No chart set has been created.</div>
      )}
    </PerfectScrollbar>
  );
}

export default ChartSetPreferenceList;
